import styled from 'styled-components';
export const BKJComponentWrapper = styled.span ``;
export const BKJTooltipArrow = styled.div `
  position: absolute;
  ::before {
    position: absolute;
    width: 10px;
    height: 10px;
    background-color: ${({ theme }) => theme.colors.Grey7};
    content: '';
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }
`;
export const BKJTooltipArrowWrapper = styled.div `
  ${({ theme }) => theme.fonts.PoppinsText};
  font-size: 14px;
  line-height: 21px;
  color: ${({ theme }) => theme.colors.TextWhite};
  background-color: ${({ theme }) => theme.colors.Grey7};
  padding: 16px;
  border-radius: 8px;
  z-index: 1000;

  &[data-popper-placement*='bottom'] {
    margin-top: 10px;
    & > .BKJTooltipArrow {
      top: -5px;
      left: -5px !important;
    }
  }

  &[data-popper-placement*='top'] {
    margin-bottom: 10px;
    & > .BKJTooltipArrow {
      bottom: 5px;
      left: -5px !important;
    }
  }

  &[data-popper-placement*='left'] {
    margin-right: 10px;
    & > .BKJTooltipArrow {
      right: 5px;
      top: -5px !important;
    }
  }

  &[data-popper-placement*='right'] {
    margin-left: 10px;
    & > .BKJTooltipArrow {
      left: -5px;
      top: -5px !important;
    }
  }
`;
//# sourceMappingURL=BKJTooltipWrapper.styled.js.map